export enum actionTypes {
    ADD_BEFORE_WITHDRAW_HOOK = 'PAYMENTS:BEFORE_WITHDRAW_HOOK:ADD'
}
